import TimeClockEntryStore from "../store/store";
import { ITimeClockEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('UPDATE_TIME_CLOCK_ENTRY', function updateTimeClockEntry(timeClockEntry: ITimeClockEntity) {
    TimeClockEntryStore().timeClockEntry = timeClockEntry;
});